import React from 'react';

export default function Footer() {

  const getFullYear = React.useCallback(() => {
    const year = new Date().getFullYear();

    return `${year} The Code Systems Solutions`;
  }, []);

  return <span className='footer'>&#169; {getFullYear()}</span>;
}
